import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { BaseViewSchema } from "./views";

export enum ViewExportStatus {
  PENDING = "pending",
  PROCESSING = "processing",
  COMPLETED = "completed",
  FAILED = "failed",
}

export enum ViewExportType {
  STANDARD = "standard",
  EXPANDED = "expanded",
}

export enum ViewExportScope {
  ALL = "all",
  SELECTED = "selected",
}

const ViewExportSchema_ = z.object({
  _id: zExt.objectId().meta({ privacy: privacy.nonPii }),
  view: BaseViewSchema.meta({ privacy: privacy.structured }),
  exportType: createEnum(ViewExportType, { enumName: "ViewExportType" }).meta({
    privacy: privacy.nonPii,
  }),
  exportScope: createEnum(ViewExportScope, {
    enumName: "ViewExportScope",
  }).meta({ privacy: privacy.nonPii }),
  status: createEnum(ViewExportStatus, { enumName: "ViewExportStatus" }).meta({
    privacy: privacy.nonPii,
  }),
  createdAt: z.date().meta({ privacy: privacy.nonPii }),
  updatedAt: z.date().meta({ privacy: privacy.nonPii }),
  team: zExt.objectId().meta({ privacy: privacy.nonPii }),
  user: zExt.objectId().meta({ privacy: privacy.nonPii }),
  fileUrl: z.string().nullish().meta({ privacy: privacy.redact }),
  selectedDocumentIds: z
    .array(z.string())
    .nullish()
    .meta({ privacy: privacy.nonPii }),
  sendToEmail: z.email().nullish().meta({ privacy: privacy.email }),
  rowsProcessed: z.number().nullish().meta({ privacy: privacy.nonPii }),
  totalRows: z.number().nullish().meta({ privacy: privacy.nonPii }),
});

export const ViewExportSchema: z.ZodType<ViewExportSchema> = ViewExportSchema_;
export interface ViewExportSchema extends z.infer<typeof ViewExportSchema_> {}
